module.exports = __webpack_public_path__ + "static/media/icon_habilitacao.1fcd9bf8.svg";